// @ts-nocheck
import { createContext, ReactNode, useContext, useEffect, useMemo, useState } from 'react'

interface TestAccountPoolProps {
  children: ReactNode
}

type TPatientForDemoGroup = {
  id: number
  firstname: string
  lastname: string
  phone: string
}

type TestAccountsPool = TPatientForDemoGroup[]

interface TestAccountPoolData {
  testAccountsPool: TestAccountsPool
  handleChangeTestAccountsPool: (items: TestAccountsPool) => void
  handleAddTestAccount: (item: TPatientForDemoGroup) => void
  isPatientInTestAccountPool: (id: number) => boolean
}

export const TestAccountPoolContext = createContext<TestAccountPoolData>({} as TestAccountPoolData)

function TestAccountPoolProvider({ children }: TestAccountPoolProps) {
  const [testAccountsPool, setTestAccountsPool] = useState<TestAccountsPool>([])

  useEffect(() => {
    const localStoragePool = localStorage?.getItem('testAccountPool')

    if (localStoragePool) {
      setTestAccountsPool(JSON.parse(localStoragePool))
    }
  }, [])

  const isPatientInTestAccountPool = (patientId: number) => {
    return testAccountsPool.some((patientInPool) => patientInPool.id === patientId)
  }

  const handleChangeTestAccountsPool = (items: TestAccountsPool) => {
    setTestAccountsPool(items)
    localStorage.setItem('testAccountPool', JSON.stringify(items))
  }

  const handleAddTestAccount = (patient: TPatientForDemoGroup) => {
    const newTestAccountsPool = [
      ...testAccountsPool,
      { id: patient.id, firstname: patient.firstname, lastname: patient.lastname, phone: patient.phone },
    ]
    setTestAccountsPool(newTestAccountsPool)
    localStorage.setItem('testAccountPool', JSON.stringify(newTestAccountsPool))
  }

  const value = useMemo(() => {
    return {
      testAccountsPool,
      handleChangeTestAccountsPool,
      handleAddTestAccount,
      isPatientInTestAccountPool,
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [testAccountsPool])

  return <TestAccountPoolContext.Provider value={value}>{children}</TestAccountPoolContext.Provider>
}

export const useTestAccountPool = () => useContext(TestAccountPoolContext)

export default TestAccountPoolProvider
